/*
 *
 * CheckoutPage reducer
 *
 */

import produce from 'immer';

export const key = 'checkoutPage';
export const initialState = null;

/* eslint-disable no-param-reassign, default-case */
function checkoutPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            default:
                return draft;
        }
    });
}

export default checkoutPageReducer;
